import { useEffect } from 'react';

export const DeleteAccountPage = () => {
  useEffect(() => {
    document.title = 'Exclusão de Conta e Dados – Joyn';
  }, []);

  return (
    <div className="min-h-screen bg-background py-10 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-card border border-border rounded-xl px-8 py-10 shadow-sm">
          <div className="flex flex-col items-center mb-8 text-center">
            <img src="/logo_eventfy.png" alt="Joyn" className="w-48 h-auto object-contain mb-6" />
            <h1 className="text-xl font-semibold text-foreground">Exclusão de Conta e Dados</h1>
            <p className="text-xs text-muted-foreground mt-1">Última atualização: Junho de 2026</p>
          </div>

          <div className="space-y-5 text-sm text-muted-foreground leading-relaxed">
            <p>
              Usuários do Joyn podem solicitar a exclusão de sua conta e dos dados associados.
            </p>

            <p>
              Atualmente, a solicitação pode ser realizada pelo e-mail{' '}
              <a href="mailto:oficialjoyn@gmail.com" className="text-primary hover:underline">
                oficialjoyn@gmail.com
              </a>
              , informando o endereço de e-mail utilizado no cadastro.
            </p>

            <p>
              Após a confirmação da solicitação, a conta será removida juntamente com os dados
              pessoais associados ao perfil do usuário, incluindo informações de cadastro,
              favoritos e preferências armazenadas na plataforma.
            </p>

            <p>
              Alguns registros poderão ser mantidos temporariamente quando exigidos por obrigações
              legais, regulatórias, de segurança ou prevenção a fraudes.
            </p>

            <p>
              As solicitações de exclusão são processadas em até 30 dias.
            </p>

            <div className="pt-2 border-t border-border">
              <p>
                Para solicitar a exclusão da conta ou esclarecer dúvidas relacionadas à privacidade
                e proteção de dados, entre em contato pelo e-mail:
              </p>
              <a
                href="mailto:oficialjoyn@gmail.com"
                className="text-primary hover:underline mt-1 inline-block"
              >
                oficialjoyn@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
